import { useFeature } from './useFeature'

export function useFlag(name: string) {
  return useFeature(name).isEnabled
}
